module.exports = __webpack_public_path__ + "img/_4.e26472c7.png";